import React from 'react';
import { UsersIcon, UtensilsIcon, WifiIcon, TreesIcon, CheckCircleIcon, DollarSignIcon } from 'lucide-react';
const features = [{
  icon: UsersIcon,
  text: 'Occupancy up to 300 people'
}, {
  icon: UtensilsIcon,
  text: 'Commercial kitchen and bar available'
}, {
  icon: WifiIcon,
  text: 'WI-FI included'
}, {
  icon: CheckCircleIcon,
  text: 'Choose your own caterer'
}, {
  icon: TreesIcon,
  text: 'Beautiful outdoor gazebo for wedding ceremonies and photos'
}, {
  icon: DollarSignIcon,
  text: 'Club members receive discounted rental rates starting in their second year of membership'
}];
export function VenueFeatures() {
  return <div className="w-full" style={{
    backgroundColor: '#f8f6f0'
  }} data-id="element-588">
      <div className="max-w-4xl mx-auto px-4 md:px-8 pt-12" data-id="element-589">
        <h2 className="text-2xl md:text-3xl font-bold uppercase mb-6" style={{
        fontFamily: 'Oswald, sans-serif',
        color: '#1e3d2f'
      }} data-id="element-590">
          Venue Features
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-591">
          {features.map(feature => {
          const Icon = feature.icon;
          return <div key={feature.text} className="bg-white rounded-xl p-5 shadow-sm border flex items-start gap-4" style={{
            borderColor: '#ede9e0'
          }} data-id="element-592">
                <div className="w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0" style={{
              backgroundColor: 'rgba(30,61,47,0.08)'
            }} data-id="element-593">
                  <Icon size={20} style={{
                color: '#1e3d2f'
              }} data-id="element-594" />
                </div>
                <p className="text-base text-gray-800 pt-1.5" style={{
              fontFamily: 'Inter, sans-serif'
            }} data-id="element-595">
                  {feature.text}
                </p>
              </div>;
        })}
        </div>
      </div>
    </div>;
}